export const validateSize = async (rule,value) => {
    if(value && !(/^([A-Z]{1,4}|\d{1,2})$/.test(value))){
        throw new Error('solamente se permiten letras mayusculas hasta 4 caracteres o numeros de hasta 2 digitos');
    }
}

export const validateType = async (rule,value) => {
    if(value && !(/^[A-Za-z]+$/.test(value))){
        throw new Error('solamente se puede ingresar una palabra');
    }
}

export const validateStatus = async (rule,value) => {
    if(value && !(value === true || value === false)){
        throw new Error('Solamente se aceptan boolenos');
    }
}